import { gql } from "apollo-boost";

export const GET_TYPE_TAX_VOUCHERS = gql`
  query getTypeTaxVouchers($where: TypeTaxVoucherWhereInput) {
    getTypeTaxVouchers(where: $where) {
      id
      name
      last
      lastSeq
      available
      prefix
      endSeq
    }
  }
`;
